import { createV1Transport, type V1Transport } from './transport'

/**
 * Transport for browser code calling the v1 API on the app's own origin. The
 * signed-in session cookie authenticates each request.
 */
export function browserV1Transport(options: { signal?: AbortSignal } = {}): V1Transport {
  return createV1Transport({ baseUrl: window.location.origin, headers: {}, ...options })
}
